import { eTransactionCategory } from '../../../../../../../ui-toolkit/enums/eTransactionType';
import {
  LENDER_BUYER_ONLY_WITH_FAXES_SIGNING_TYPE_NAME,
  LENDER_SELLER_ONLY_WITH_FAXES_SIGNING_TYPE_NAME,
  REFINANCE_FAXES_SIGNING_TYPE_NAME,
} from '../../../../../../../types/signingAppointment/ISigningTypeResponse';
import { eCreateSigningAppointmentFormDataOwnerTypes } from '../../../../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';

const getSigningTypeForBorrower = (transactionCategory: eTransactionCategory) => {
  if (transactionCategory === eTransactionCategory.Refinance) {
    return REFINANCE_FAXES_SIGNING_TYPE_NAME;
  }
  return LENDER_BUYER_ONLY_WITH_FAXES_SIGNING_TYPE_NAME;
};

export const getDefaultSigningTypeFromAppointmentType = (
  ownerType: eCreateSigningAppointmentFormDataOwnerTypes,
  transactionCategory: eTransactionCategory
): string => {
  switch (ownerType) {
    case eCreateSigningAppointmentFormDataOwnerTypes.borrower:
    case eCreateSigningAppointmentFormDataOwnerTypes.borrowerEmail:
      return getSigningTypeForBorrower(transactionCategory);
    case eCreateSigningAppointmentFormDataOwnerTypes.seller:
    case eCreateSigningAppointmentFormDataOwnerTypes.sellerEmail:
      return LENDER_SELLER_ONLY_WITH_FAXES_SIGNING_TYPE_NAME;
    default:
      return '';
  }
};
